import React, { useEffect } from "react";

const paragraphs = [
  "Aviso legal",
  "Ley Protección de Datos de Carácter Personal",
  "De conformidad con lo establecido en Reglamento (UE) 2016/679 del Parlamento Europeo de Protección de Datos de Carácter Personal, y de la Ley Orgánica 3/2018, de 5 de diciembre (LOPDGDD), se informa al Cliente/Usuario de que los datos personales que nos facilita serán incluidos en un Registro de Actividades titularidad de SINERGY SMK S.L., con la finalidad de realizar una correcta gestión de la relación comercial, así como para informarle de novedades, productos y/o servicios tanto por medios escritos como electrónicos.",
  "Vd. podrá en cualquier momento revocar el consentimiento prestado para el envío de comunicaciones comerciales electrónicas remitiendo un correo a la dirección hola@chachophone.com",
  "Finalmente, le informamos de que puede ejercer sus derechos de acceso, rectificación, cancelación y/u oposición, limitación de tratamiento, y portabilidad, así como revocación del consentimiento prestado, dirigiéndose por escrito a SINERGY SMK S.L. sita en C/ Garcilaso De La Vega 21, Local 12, 38005 Santa Cruz de Tenerife, España.",
  "Ley de Servicios de la Información y Comercio Electrónico",
  "Según la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico, se comunican los siguientes datos sobre el dominio de WWW.CHACHOPHONE.COM",
  "Titular del Dominio",
  "SINERGY SMK S.L.",
  "CIF B-26765602",
  "C/ Garcilaso De La Vega 21, Local 12, 38005 Santa Cruz de Tenerife, España.",
  "Correo electrónico: hola@chachophone.com",
  "Nombre del dominio:",
  "WWW.CHACHOPHONE.COM",
];


export default function AvisoLegal() {
  useEffect(() => {
  window.scrollTo(0, 0);
}, []);

  return (
    <div
      style={{
        backgroundColor: "#ffffff",
        color: "#000000",
        minHeight: "100vh",
        padding: "48px 24px",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div style={{ maxWidth: "850px", width: "100%" }}>
        {paragraphs.map((text, i) => (
          <p
            key={i}
            style={{
              fontFamily: "Arial, Helvetica, sans-serif",
              fontWeight: 400,
              fontStyle: "normal",
              fontSize: "16px",
              lineHeight: 1.6,
              color: "#000000",
              margin: "0 0 20px 0",
            }}
          >
            {text}
          </p>
        ))}
      </div>
    </div>
  );
}